export default __webpack_public_path__ + "static/6_17-650b8d578166b5de13135254fd3fb65a.png";